var _defs, _path, _path2, _path3, _path4, _path5;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgStats = function SvgStats(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    opactity: 0.8,
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opactity: 0.8,
    fill: "#FFF",
    d: "M88.06,82.54v6.52H11.94V82.54Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opactity: 0.8,
    fill: "#FFF",
    d: "M87.84,77.59H77V13.29a4.83,4.83,0,0,1,4.83-4.83H83a4.83,4.83,0,0,1,4.83,4.83Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opactity: 0.8,
    fill: "#FFF",
    d: "M23,77.68H12.19V15.24A4.83,4.83,0,0,1,17,10.42h1.14A4.82,4.82,0,0,1,23,15.24Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opactity: 0.8,
    fill: "#FFF",
    d: "M44.45,77.64H33.82V30.37a4.83,4.83,0,0,1,4.83-4.83h1a4.83,4.83,0,0,1,4.83,4.83Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opactity: 0.8,
    fill: "#FFF",
    d: "M60.28,40.84h1.11a4.83,4.83,0,0,1,4.83,4.83V77.53H55.45V45.67A4.83,4.83,0,0,1,60.28,40.84Z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStats, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stats.38061ea8.svg";
export { ForwardRef as ReactComponent };